var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDueDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 15.1a1.8 1.8 0 0 0-3.3 1.6 21 21 0 0 1-2.4 22.4 21.3 21.3 0 1 1-4.9-30.8 1.8 1.8 0 1 0 2-3 25 25 0 1 0 8.6 9.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 9.5a1.8 1.8 0 0 0-1.8 1.9v14.8c0 .5.2 1 .5 1.3l8.5 8.5a1.8 1.8 0 0 0 2.6-2.6l-8-8v-14A1.8 1.8 0 0 0 25 9.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDueDate);
export default __webpack_public_path__ + "static/media/due-date.8c180a97.svg";
export { ForwardRef as ReactComponent };